
import { defineComponent, PropType, ref, watch } from 'vue'
import EditableBlock from '@/components/EditableBlock.vue'
import { Tenant } from '@/pages/Settings/components/editors/TenantConfigEditor.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import Tooltip from '@/components/Tooltip.vue'
import EditableBlockIbanInput from '@/components/EditableBlockIbanInput.vue'

export default defineComponent({
  name: 'BusinessRegistrationDetails',
  components: { EditableBlockIbanInput, Tooltip, EditableBlockInput, EditableBlock },
  emits: ['update:business-registration-details'],
  props: {
    tenant: {
      type: Object as PropType<Tenant>,
    }
  },

  setup (props) {
    const businessRegistrationDetails = ref({
      financial: {}, tax: {}, registration: {},
      ...props.tenant?.settings?.company
    })

    watch(() => props.tenant, () => {

      businessRegistrationDetails.value = {
        financial: {}, tax: {}, registration: {},
        ...props.tenant?.settings?.company
      }
    })

    return {
      businessRegistrationDetails
    }
  }
})
